var app = angular.module("leonardo");

var DeletePresenterDialog = function($scope, FormErrorsService) {
  $scope.object = $scope.ngDialogData.object;
  $scope.alert_message = $scope.ngDialogData.alert_message;
  $scope.type = $scope.ngDialogData.type;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.data);
  };
};

app.controller('DeletePresenterDialog', ['$scope', 'FormErrorsService', DeletePresenterDialog ]);
